import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, MessageCircle } from 'lucide-react';
import { navLinks, profile } from '../mock';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,backdrop-filter,border] duration-500 ${
        scrolled
          ? 'bg-[#F4EDE2]/85 backdrop-blur-md border-b border-[#DBCEB4]'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <span className="w-9 h-9 rounded-full bg-[#B8806E] text-[#FAF4E8] grid place-items-center font-serif text-lg leading-none">
            k
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-serif text-[19px] text-[#2E2A23] tracking-tight">
              Karina Negrín
            </span>
            <span className="text-[10px] tracking-[0.28em] uppercase text-[#8A7E6E]">
              Psicóloga · Lactancia
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((link) =>
            link.external ? (
              <Link
                key={link.href}
                to={link.href}
                className="text-[13px] tracking-[0.14em] uppercase text-[#2E2A23]/80 hover:text-[#B8806E] transition-colors duration-300"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                className="text-[13px] tracking-[0.14em] uppercase text-[#2E2A23]/80 hover:text-[#B8806E] transition-colors duration-300"
              >
                {link.label}
              </a>
            )
          )}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={profile.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="btn-primary text-[12px] px-5 py-3"
          >
            <MessageCircle size={16} strokeWidth={1.6} />
            Agendar consulta
          </a>
        </div>

        <button
          aria-label="Abrir menú"
          className="lg:hidden w-10 h-10 grid place-items-center rounded-full border border-[#C5B496] text-[#2E2A23]"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height,opacity] duration-500 ease-out ${
          open ? 'max-h-[520px] opacity-100' : 'max-h-0 opacity-0'
        } bg-[#F4EDE2] border-t border-[#DBCEB4]`}
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) =>
            link.external ? (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setOpen(false)}
                className="text-[15px] tracking-[0.06em] text-[#2E2A23] py-1"
              >
                {link.label}
              </Link>
            ) : (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="text-[15px] tracking-[0.06em] text-[#2E2A23] py-1"
              >
                {link.label}
              </a>
            )
          )}
          <a
            href={profile.whatsapp}
            target="_blank"
            rel="noreferrer"
            className="btn-primary self-start mt-2"
          >
            <MessageCircle size={16} strokeWidth={1.6} />
            Agendar consulta
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
